import { Injectable } from '@angular/core';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouteContextService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  /**
   * Returns child-most Data from ActivatedRoute tree
   * @returns static Data associated with the current ActivatedRoute
   */
  getActivatedRouteData(): Observable<Data> {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        return this.getChildData();
      }),
    );
  }

  getCurrentActivatedRouteData(): Data {
    return this.getChildData();
  }

  /** Returns child-most Data from ActivatedRoute tree */
  private getChildData(): Data {
    let currentRoute = this.activatedRoute;
    while (currentRoute) {
      if (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      } else if (currentRoute.snapshot.data) {
        return currentRoute.snapshot.data;
      } else {
        return null;
      }
    }
    return null;
  }
}
